import gql from 'graphql-tag';
export const StatFeatureCustomRegistrationForms = gql `
    fragment StatFeatureCustomRegistrationForms on CustomRegistrationFormsFeatureSettingsFlags {
        isEnabled
    }
`;
